import browserCheck from '@/utils/checkBrowser'

export function throttle(func, delay, _this) {
  let timer
  return function() {
    let nowTimer = +new Date()

    if (nowTimer - timer < delay) {
      return
    }
    timer = nowTimer
    func.apply(_this)
  }
}

/**
 * 获取url参数并转为对象
 * 输入不正确或获取不到参数时返回空对象
 * @param {string} string 可以是完整的url，也可以是query string
 */
export function query2json (string) {
  let queryMatch = string.split('?')
  let query = queryMatch[1] || queryMatch[0]
  const paramsJson = {}
  query.split('&').forEach(item => {
    let kvArr = item.split('=')
    if (kvArr.length > 1) {
      let tempObj = {}
      tempObj[kvArr[0]] = kvArr[1]
      Object.assign(paramsJson, tempObj)
    }
  })
  return paramsJson
}

export function json2query (json) {
  let query = ''
  for (const key in json) {
    query += json[key] + '&'
  }
  query = query.substring(0, query.length - 1)
  return query
}

export function setHtmlHeight(arr) {
  let viewHeight =
    document.documentElement.clientHeight || document.body.clientHeight
  let html = document.querySelector('html')
  let body = document.querySelector('body')
  let app = document.querySelector('#app')
  html.style.height = viewHeight + 'px'
  html.style.minHeight = 0
  body.style.height = viewHeight + 'px'
  body.style.minHeight = 0
  app.style.height = viewHeight + 'px'
  app.style.minHeight = 0
  arr.forEach(element => {
    let ele = document.querySelector(element)
    ele.style.height = '100%'
    ele.style.minHeight = 0
  })
}
/**
 * 做单屏页面时执行该函数
 * @param {Array} arr 如：['.main', '.container']
 */
export function setSafairHeight(arr) {
  if (browserCheck.isSafari) {
    setHtmlHeight(arr)
  }
}
